/**
 * 尺码指南计算器 JavaScript - 儿童版本
 * 提供儿童尺码计算功能
 */

// 全局函数，用于打开尺码计算器（提前定义以确保在onclick调用时可用）
if (typeof window.openBraSizeCalculator === 'undefined') {
  window.openBraSizeCalculator = function(type = 'women') {
    const modalId = type === 'men' ? 'bra-size-calculator-men' : 
                     type === 'kids' ? 'bra-size-calculator-kids' : 
                     'bra-size-calculator-women';
    
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
      // 设置 main 元素的 z-index，防止被 header 覆盖
      const mainElement = document.querySelector('.main');
      if (mainElement) {
        mainElement.style.zIndex = '501';
      }
    }
  };
}

// 儿童尺码计算器类
class KidsSizeCalculator {
  constructor() {
    this.modal = null;
    this.type = 'kids';
    this.recommendedSize = null;
    this.recommendedSizeUS = null;
    this.mouseDownOnContent = false;
  }

  init() {
    this.bindEvents();
    this.generateSizeTable();
    // 初始化时更新 placeholder
    this.updateKidsBraInputPlaceholder();
    this.updateKidsLoungeInputPlaceholder();
  }

  bindEvents() {
    if (!this.modal) return;
    
    // 关闭模态框
    this.modal.querySelectorAll('[data-close-modal]').forEach(trigger => {
      trigger.addEventListener('click', () => this.closeModal());
    });

    // Tab 切换
    this.modal.querySelectorAll('.bra-size-calculator__tab').forEach(tab => {
      tab.addEventListener('click', (e) => {
        const tabName = e.target.dataset.tab;
        this.switchTab(tabName);
      });
    });

    // Girls Bra Size tab 相关事件
    // Size Type 选择器（Girls Bra Size）
    const sizeTypeSelectBra = this.modal.querySelector('#size-type-kids-bra');
    if (sizeTypeSelectBra) {
      const initialSizeType = sizeTypeSelectBra.value || 'us';
      if (initialSizeType) {
        const event = new Event('change');
        sizeTypeSelectBra.value = initialSizeType;
        sizeTypeSelectBra.dispatchEvent(event);
      }
      
      sizeTypeSelectBra.addEventListener('change', () => {
        const resultElement = document.getElementById('recommended-size-kids-bra');
        const resultContainer = document.getElementById('size-result-kids-bra');
        if (resultElement && resultContainer && resultContainer.style.display !== 'none' && this.recommendedSizeUS) {
          const sizeType = sizeTypeSelectBra.value;
          const recommendedSize = sizeType === 'eu' ? this.recommendedSizeEU : this.recommendedSizeUS;
          resultElement.textContent = recommendedSize;
        }
      });
    }

    // 单位切换按钮（Girls Bra Size）
    this.modal.querySelectorAll('[data-unit][data-type="kids-bra"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.handleUnitToggle(e.target.dataset.unit, 'kids-bra');
      });
    });

    // 计算 Girls Bra Size
    const calculateBraBtn = this.modal.querySelector('[data-calculate-bra-size-kids]');
    if (calculateBraBtn) {
      calculateBraBtn.addEventListener('click', () => this.calculateBraSizeKids());
    }

    // Girls Bra Size 输入框回车键触发查询
    const braHeightInput = document.getElementById('height-measurement-kids-bra');
    if (braHeightInput) {
      braHeightInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.calculateBraSizeKids();
        }
      });
    }

    // Lounge tab 相关事件
    // Size Type 选择器（Lounge）
    const sizeTypeSelectLounge = this.modal.querySelector('#size-type-kids-lounge');
    if (sizeTypeSelectLounge) {
      const initialSizeType = sizeTypeSelectLounge.value || 'us';
      if (initialSizeType) {
        const event = new Event('change');
        sizeTypeSelectLounge.value = initialSizeType;
        sizeTypeSelectLounge.dispatchEvent(event);
      }
      
      sizeTypeSelectLounge.addEventListener('change', () => {
        const resultElement = document.getElementById('recommended-size-kids-lounge');
        const resultContainer = document.getElementById('size-result-kids-lounge');
        if (resultElement && resultContainer && resultContainer.style.display !== 'none' && this.recommendedLoungeSizeUS) {
          const sizeType = sizeTypeSelectLounge.value;
          const recommendedSize = sizeType === 'eu' ? this.recommendedLoungeSizeEU : this.recommendedLoungeSizeUS;
          resultElement.textContent = recommendedSize;
        }
      });
    }

    // 单位切换按钮（Lounge）
    this.modal.querySelectorAll('[data-unit][data-type="kids-lounge"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.handleUnitToggle(e.target.dataset.unit, 'kids-lounge');
      });
    });

    // 计算 Lounge Size
    const calculateLoungeBtn = this.modal.querySelector('[data-calculate-lounge-size-kids]');
    if (calculateLoungeBtn) {
      calculateLoungeBtn.addEventListener('click', () => this.calculateLoungeSizeKids());
    }

    // Lounge 输入框回车键触发查询
    const loungeHeightInput = document.getElementById('height-measurement-kids-lounge');
    if (loungeHeightInput) {
      loungeHeightInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.calculateLoungeSizeKids();
        }
      });
    }

    // ESC键关闭
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.style.display !== 'none') {
        this.closeModal();
      }
    });

    // 记录鼠标是否在弹框内容区域按下
    this.modal.addEventListener('mousedown', (e) => {
      this.mouseDownOnContent = e.target !== this.modal;
    });

    // 点击外部关闭
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal && !this.mouseDownOnContent) {
        this.closeModal();
      }
      this.mouseDownOnContent = false;
    });
  }

  switchTab(tabName) {
    if (!this.modal) return;
    
    // 更新标签页状态
    this.modal.querySelectorAll('.bra-size-calculator__tab').forEach(tab => {
      tab.classList.remove('active');
    });
    const activeTab = this.modal.querySelector(`[data-tab="${tabName}"]`);
    if (activeTab) activeTab.classList.add('active');

    // 更新面板状态
    this.modal.querySelectorAll('.bra-size-calculator__panel').forEach(panel => {
      panel.classList.remove('active');
      panel.style.display = 'none';
    });
    const activePanel = this.modal.querySelector(`[data-panel="${tabName}"]`);
    if (activePanel) {
      activePanel.classList.add('active');
      activePanel.style.display = 'block';
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
      const mainElement = document.querySelector('.main');
      if (mainElement) {
        mainElement.style.zIndex = '';
      }
    }
  }

  calculateBraSizeKids() {
    const heightInput = document.getElementById('height-measurement-kids-bra');
    const stageSelect = document.getElementById('stage-type-kids-bra');
    const sizeTypeSelect = document.getElementById('size-type-kids-bra');
    
    if (!heightInput || !stageSelect || !sizeTypeSelect) return;
    
    let heightMeasurement = parseFloat(heightInput.value);
    
    if (!heightMeasurement || isNaN(heightMeasurement)) {
      alert('Please enter a height measurement');
      return;
    }

    const currentUnit = this.getCurrentUnit('kids-bra');
    const stage = stageSelect.value;
    const sizeType = sizeTypeSelect.value;
    
    // 转换为厘米进行计算
    if (currentUnit === 'in') {
      heightMeasurement = heightMeasurement * 2.54;
    }

    // Girls Bra Size 数据 - 分别存储 CM 和 INCH 数据，不进行转换
    const braSizeDataCM = {
      first: [
        { sizeUS: '10Y', sizeEU: '128', heightRange: [135, 145], weightRange: [30, 35], bustRange: [61, 67], bandRange: null, differenceRange: [0, 5] },
        { sizeUS: '12Y', sizeEU: '134', heightRange: [145, 155], weightRange: [35, 45], bustRange: [65, 71], bandRange: null, differenceRange: [0, 5] },
        { sizeUS: '14Y', sizeEU: '140', heightRange: [155, 165], weightRange: [42.5, 50], bustRange: [69, 75], bandRange: null, differenceRange: [0, 5] },
        { sizeUS: '18Y', sizeEU: '152', heightRange: [165, 175], weightRange: [50, 60], bustRange: [73, 80], bandRange: null, differenceRange: [0, 5] }
      ],
      second: [
        { sizeUS: '12Y', sizeEU: '134', heightRange: [145, 155], weightRange: [35, 45], bustRange: [68, 75], bandRange: [60, 68], differenceRange: [5, 10] },
        { sizeUS: '14Y', sizeEU: '140', heightRange: [155, 165], weightRange: [40, 50], bustRange: [75, 82], bandRange: [70, 75], differenceRange: [5, 10] },
        { sizeUS: '18Y', sizeEU: '152', heightRange: [165, 175], weightRange: [50, 60], bustRange: [82, 89], bandRange: [75, 80], differenceRange: [5, 10] }
      ],
      third: [
        { sizeUS: '14Y', sizeEU: '140', heightRange: [155, 165], weightRange: [40, 50], bustRange: [77, 82], bandRange: [65, 70], differenceRange: [7.5, 12.5] },
        { sizeUS: '16Y', sizeEU: '146', heightRange: [165, 170], weightRange: [45, 57], bustRange: [82, 87], bandRange: [70, 75], differenceRange: [7.5, 12.5] },
        { sizeUS: '18Y', sizeEU: '152', heightRange: [170, 175], weightRange: [57, 67], bustRange: [87, 92], bandRange: [75, 80], differenceRange: [7.5, 12.5] },
        { sizeUS: '18Y', sizeEU: '158', heightRange: [175, 180], weightRange: [67, 77], bustRange: [92, 97], bandRange: [80, 85], differenceRange: [7.5, 12.5] }
      ]
    };
    
    const braSizeDataIN = {
      first: [
        { sizeUS: '10Y', sizeEU: '128', heightRange: [53, 57], weightRange: [30, 35], bustRange: [24, 26.5], bandRange: null, differenceRange: [0, 2] },
        { sizeUS: '12Y', sizeEU: '134', heightRange: [57, 61], weightRange: [35, 45], bustRange: [25.5, 28], bandRange: null, differenceRange: [0, 2] },
        { sizeUS: '14Y', sizeEU: '140', heightRange: [61, 65], weightRange: [42.5, 50], bustRange: [27.5, 29.5], bandRange: null, differenceRange: [0, 2] },
        { sizeUS: '18Y', sizeEU: '152', heightRange: [65, 69], weightRange: [50, 60], bustRange: [28.5, 31.5], bandRange: null, differenceRange: [0, 2] }
      ],
      second: [
        { sizeUS: '12Y', sizeEU: '134', heightRange: [57, 61], weightRange: [35, 45], bustRange: [27, 29.5], bandRange: [23.5, 27], differenceRange: [2, 4] },
        { sizeUS: '14Y', sizeEU: '140', heightRange: [61, 65], weightRange: [40, 50], bustRange: [29.5, 32.5], bandRange: [27.5, 29.5], differenceRange: [2, 4] },
        { sizeUS: '18Y', sizeEU: '152', heightRange: [65, 69], weightRange: [50, 60], bustRange: [32.5, 35], bandRange: [29.5, 31.5], differenceRange: [2, 4] }
      ],
      third: [
        { sizeUS: '14Y', sizeEU: '140', heightRange: [61, 65], weightRange: [40, 50], bustRange: [30.5, 32.5], bandRange: [25.5, 27.6], differenceRange: [3, 5] },
        { sizeUS: '16Y', sizeEU: '146', heightRange: [65, 67], weightRange: [45, 57], bustRange: [32.5, 34.5], bandRange: [27.5, 29.5], differenceRange: [3, 5] },
        { sizeUS: '18Y', sizeEU: '152', heightRange: [67, 69], weightRange: [57, 67], bustRange: [34.5, 36.5], bandRange: [29.5, 31.5], differenceRange: [3, 5] },
        { sizeUS: '18Y', sizeEU: '158', heightRange: [69, 71], weightRange: [67, 77], bustRange: [36, 38], bandRange: [31.5, 33.5], differenceRange: [3, 5] }
      ]
    };
    
    // 计算时统一转换为 CM 进行比较
    const braSizeData = currentUnit === 'cm' ? braSizeDataCM : {
      first: braSizeDataIN.first.map(item => ({
        ...item,
        heightRange: item.heightRange.map(h => h * 2.54)
      })),
      second: braSizeDataIN.second.map(item => ({
        ...item,
        heightRange: item.heightRange.map(h => h * 2.54)
      })),
      third: braSizeDataIN.third.map(item => ({
        ...item,
        heightRange: item.heightRange.map(h => h * 2.54)
      }))
    };

    const sizeData = braSizeData[stage] || [];
    if (sizeData.length === 0) return;

    // 根据身高匹配尺码（heightMeasurement 已经是 CM）
    let bestMatch = null;
    let bestScore = 0;
    const tolerance = 5;

    sizeData.forEach((sizeInfo, index) => {
      let score = 0;
      const range = sizeInfo.heightRange;
      const isLastRange = index === sizeData.length - 1;
      
      if (isLastRange) {
        if (heightMeasurement >= range[0] && heightMeasurement <= range[1]) {
          score = 10;
        } else if (heightMeasurement >= range[0] - tolerance && heightMeasurement <= range[1] + tolerance) {
          score = 5;
        } else {
          const mid = (range[0] + range[1]) / 2;
          const distance = Math.abs(heightMeasurement - mid);
          score = Math.max(0, 5 - distance / tolerance);
        }
      } else {
        if (heightMeasurement >= range[0] && heightMeasurement < range[1]) {
          score = 10;
        } else if (heightMeasurement >= range[0] - tolerance && heightMeasurement < range[1] + tolerance) {
          score = 5;
        } else {
          const mid = (range[0] + range[1]) / 2;
          const distance = Math.abs(heightMeasurement - mid);
          score = Math.max(0, 5 - distance / tolerance);
        }
      }

      if (score > bestScore) {
        bestScore = score;
        bestMatch = sizeInfo;
      }
    });

    if (!bestMatch) {
      alert('Unable to find a matching size. Please check your measurements.');
      return;
    }

    const recommendedSize = sizeType === 'eu' ? bestMatch.sizeEU : bestMatch.sizeUS;
    
    const resultElement = document.getElementById('recommended-size-kids-bra');
    const resultContainer = document.getElementById('size-result-kids-bra');
    
    if (resultElement) resultElement.textContent = recommendedSize;
    if (resultContainer) resultContainer.style.display = 'block';
    
    this.recommendedSize = recommendedSize;
    this.recommendedSizeUS = bestMatch.sizeUS;
    this.recommendedSizeEU = bestMatch.sizeEU;

    resultContainer.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center' 
    });
  }

  calculateLoungeSizeKids() {
    const heightInput = document.getElementById('height-measurement-kids-lounge');
    const sizeTypeSelect = document.getElementById('size-type-kids-lounge');
    
    if (!heightInput || !sizeTypeSelect) return;
    
    let heightMeasurement = parseFloat(heightInput.value);
    
    if (!heightMeasurement || isNaN(heightMeasurement)) {
      alert('Please enter a height measurement');
      return;
    }

    const currentUnit = this.getCurrentUnit('kids-lounge');
    const sizeType = sizeTypeSelect.value;
    
    // 转换为厘米进行计算
    if (currentUnit === 'in') {
      heightMeasurement = heightMeasurement * 2.54;
    }

    // Lounge/ Layers/ Underwear/ Top Size 数据 - 分别存储 CM 和 INCH 数据
    // 计算时统一转换为 CM 进行比较
    const loungeSizeDataCM = [
      { sizeUS: '18-24 months', sizeEU: '18-24 months', heightRange: [85, 95], bustRange: [47, 53], waistRange: [47, 53], hipsRange: [49, 55] },
      { sizeUS: '3 years', sizeEU: '3 years', heightRange: [95, 105], bustRange: [49, 55], waistRange: [48, 54], hipsRange: [51, 57] },
      { sizeUS: '4 years', sizeEU: '110', heightRange: [105, 115], bustRange: [53, 59], waistRange: [49, 56], hipsRange: [54, 62] },
      { sizeUS: '6Y', sizeEU: '116', heightRange: [115, 125], bustRange: [57, 63], waistRange: [50, 59], hipsRange: [58, 66] },
      { sizeUS: '8Y', sizeEU: '122', heightRange: [125, 135], bustRange: [61, 67], waistRange: [51, 62], hipsRange: [62, 70] },
      { sizeUS: '10Y', sizeEU: '128', heightRange: [135, 145], bustRange: [63, 71], waistRange: [52, 64], hipsRange: [68, 76] },
      { sizeUS: '12Y', sizeEU: '134', heightRange: [145, 155], bustRange: [64, 76], waistRange: [56, 67], hipsRange: [72, 82] },
      { sizeUS: '14Y', sizeEU: '140', heightRange: [155, 160], bustRange: [68, 80], waistRange: [58, 70], hipsRange: [74, 84] },
      { sizeUS: '14Y', sizeEU: '140', heightRange: [160, 165], bustRange: [72, 84], waistRange: [61, 74], hipsRange: [78, 88] },
      { sizeUS: '16Y', sizeEU: '146', heightRange: [165, 170], bustRange: [76, 88], waistRange: [64, 78], hipsRange: [82, 92] },
      { sizeUS: '18Y', sizeEU: '152', heightRange: [170, 175], bustRange: [80, 92], waistRange: [67, 80], hipsRange: [86, 96] },
      { sizeUS: '18Y', sizeEU: '158', heightRange: [175, 180], bustRange: [84, 96], waistRange: [70, 82], hipsRange: [90, 100] },
      { sizeUS: '18Y', sizeEU: '164', heightRange: [170, 185], bustRange: [92, 100], waistRange: [78, 86], hipsRange: [96, 104] }
    ];
    
    const loungeSizeDataIN = [
      { sizeUS: '18-24 months', sizeEU: '18-24 months', heightRange: [33.5, 37.5], bustRange: [18.5, 21], waistRange: [18.5, 21], hipsRange: [19.5, 21.5] },
      { sizeUS: '3 years', sizeEU: '3 years', heightRange: [37.5, 41.5], bustRange: [19.5, 21.5], waistRange: [19, 21.5], hipsRange: [20, 22.5] },
      { sizeUS: '4 years', sizeEU: '110', heightRange: [41.5, 45.5], bustRange: [21, 23], waistRange: [19.5, 22], hipsRange: [21.5, 24.5] },
      { sizeUS: '6Y', sizeEU: '116', heightRange: [45.5, 49], bustRange: [22.5, 25], waistRange: [20, 23], hipsRange: [23, 26] },
      { sizeUS: '8Y', sizeEU: '122', heightRange: [49, 53], bustRange: [24.0, 26.5], waistRange: [20, 24.5], hipsRange: [24.5, 27.5] },
      { sizeUS: '10Y', sizeEU: '128', heightRange: [53, 57], bustRange: [25, 28.0], waistRange: [20.5, 25], hipsRange: [27, 30] },
      { sizeUS: '12Y', sizeEU: '134', heightRange: [57, 61], bustRange: [25, 30], waistRange: [22, 26.5], hipsRange: [28.5, 32.5] },
      { sizeUS: '14Y', sizeEU: '140', heightRange: [61, 63], bustRange: [27, 31.5], waistRange: [23, 27.5], hipsRange: [29, 33] },
      { sizeUS: '14Y', sizeEU: '140', heightRange: [63, 65], bustRange: [28.5, 33], waistRange: [24, 29], hipsRange: [31, 34.5] },
      { sizeUS: '16Y', sizeEU: '146', heightRange: [65, 67], bustRange: [30, 34.5], waistRange: [25, 30.5], hipsRange: [32.5, 36] },
      { sizeUS: '18Y', sizeEU: '152', heightRange: [67, 69], bustRange: [31.5, 36], waistRange: [26.5, 31.5], hipsRange: [34, 38] },
      { sizeUS: '18Y', sizeEU: '158', heightRange: [69, 71], bustRange: [33, 38], waistRange: [27.5, 32.5], hipsRange: [35.5, 39.5] },
      { sizeUS: '18Y', sizeEU: '164', heightRange: [71, 72.5], bustRange: [36, 39.5], waistRange: [30.5, 34], hipsRange: [38, 41] }
    ];
    
    // 计算时统一转换为 CM
    const loungeSizeData = currentUnit === 'cm' ? loungeSizeDataCM : loungeSizeDataIN.map(item => ({
      ...item,
      heightRange: item.heightRange.map(h => h * 2.54),
      bustRange: item.bustRange.map(b => b * 2.54),
      waistRange: item.waistRange.map(w => w * 2.54),
      hipsRange: item.hipsRange.map(h => h * 2.54)
    }));

    // 根据身高匹配尺码
    let bestMatch = null;
    let bestScore = 0;
    const tolerance = 5;

    loungeSizeData.forEach((sizeInfo, index) => {
      let score = 0;
      const range = sizeInfo.heightRange;
      const isLastRange = index === loungeSizeData.length - 1;
      
      if (isLastRange) {
        if (heightMeasurement >= range[0] && heightMeasurement <= range[1]) {
          score = 10;
        } else if (heightMeasurement >= range[0] - tolerance && heightMeasurement <= range[1] + tolerance) {
          score = 5;
        } else {
          const mid = (range[0] + range[1]) / 2;
          const distance = Math.abs(heightMeasurement - mid);
          score = Math.max(0, 5 - distance / tolerance);
        }
      } else {
        if (heightMeasurement >= range[0] && heightMeasurement < range[1]) {
          score = 10;
        } else if (heightMeasurement >= range[0] - tolerance && heightMeasurement < range[1] + tolerance) {
          score = 5;
        } else {
          const mid = (range[0] + range[1]) / 2;
          const distance = Math.abs(heightMeasurement - mid);
          score = Math.max(0, 5 - distance / tolerance);
        }
      }

      if (score > bestScore) {
        bestScore = score;
        bestMatch = sizeInfo;
      }
    });

    if (!bestMatch) {
      alert('Unable to find a matching size. Please check your measurements.');
      return;
    }

    const recommendedSize = sizeType === 'eu' ? bestMatch.sizeEU : bestMatch.sizeUS;
    
    const resultElement = document.getElementById('recommended-size-kids-lounge');
    const resultContainer = document.getElementById('size-result-kids-lounge');
    
    if (resultElement) resultElement.textContent = recommendedSize;
    if (resultContainer) resultContainer.style.display = 'block';
    
    this.recommendedLoungeSize = recommendedSize;
    this.recommendedLoungeSizeUS = bestMatch.sizeUS;
    this.recommendedLoungeSizeEU = bestMatch.sizeEU;

    resultContainer.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center' 
    });
  }

  generateSizeTable() {
    // 生成 Girls Bra Size 表格
    const braTableBody = this.modal ? 
      this.modal.querySelector('#bra-size-table-body-kids') :
      document.getElementById('bra-size-table-body-kids');
    if (braTableBody) {
      this.generateBraSizeTable(braTableBody);
    }
    
    // 生成 Lounge Size 表格
    const loungeTableBody = this.modal ? 
      this.modal.querySelector('#lounge-size-table-body-kids') :
      document.getElementById('lounge-size-table-body-kids');
    if (loungeTableBody) {
      this.generateLoungeSizeTable(loungeTableBody);
    }
  }

  generateBraSizeTable(tableBody) {
    if (!tableBody) return;
    
    tableBody.innerHTML = '';
    const currentUnit = this.getCurrentUnit('kids-bra');
    
    // Girls Bra Size 数据 - 分别存储 CM 和 INCH 数据，不进行转换
    const braSizeDataCM = {
      first: [
        { stage: 'First stage (8-12 years old)', sizeUS: '10Y', sizeEU: '128', heightRange: [135, 145], weightRange: [30, 35], bustRange: [61, 67], bandRange: null, differenceRange: [0, 5] },
        { stage: 'First stage (8-12 years old)', sizeUS: '12Y', sizeEU: '134', heightRange: [145, 155], weightRange: [35, 45], bustRange: [65, 71], bandRange: null, differenceRange: [0, 5] },
        { stage: 'First stage (8-12 years old)', sizeUS: '14Y', sizeEU: '140', heightRange: [155, 165], weightRange: [42.5, 50], bustRange: [69, 75], bandRange: null, differenceRange: [0, 5] },
        { stage: 'First stage (8-12 years old)', sizeUS: '18Y', sizeEU: '152', heightRange: [165, 175], weightRange: [50, 60], bustRange: [73, 80], bandRange: null, differenceRange: [0, 5] }
      ],
      second: [
        { stage: 'Second stage (12-14 years)', sizeUS: '12Y', sizeEU: '134', heightRange: [145, 155], weightRange: [35, 45], bustRange: [68, 75], bandRange: [60, 68], differenceRange: [5, 10] },
        { stage: 'Second stage (12-14 years)', sizeUS: '14Y', sizeEU: '140', heightRange: [155, 165], weightRange: [40, 50], bustRange: [75, 82], bandRange: [70, 75], differenceRange: [5, 10] },
        { stage: 'Second stage (12-14 years)', sizeUS: '18Y', sizeEU: '152', heightRange: [165, 175], weightRange: [50, 60], bustRange: [82, 89], bandRange: [75, 80], differenceRange: [5, 10] }
      ],
      third: [
        { stage: 'Third stage (14-16 years old)', sizeUS: '14Y', sizeEU: '140', heightRange: [155, 165], weightRange: [40, 50], bustRange: [77, 82], bandRange: [65, 70], differenceRange: [7.5, 12.5] },
        { stage: 'Third stage (14-16 years old)', sizeUS: '16Y', sizeEU: '146', heightRange: [165, 170], weightRange: [45, 57], bustRange: [82, 87], bandRange: [70, 75], differenceRange: [7.5, 12.5] },
        { stage: 'Third stage (14-16 years old)', sizeUS: '18Y', sizeEU: '152', heightRange: [170, 175], weightRange: [57, 67], bustRange: [87, 92], bandRange: [75, 80], differenceRange: [7.5, 12.5] },
        { stage: 'Third stage (14-16 years old)', sizeUS: '18Y', sizeEU: '158', heightRange: [175, 180], weightRange: [67, 77], bustRange: [92, 97], bandRange: [80, 85], differenceRange: [7.5, 12.5] }
      ]
    };
    
    const braSizeDataIN = {
      first: [
        { stage: 'First stage (8-12 years old)', sizeUS: '10Y', sizeEU: '128', heightRange: [53, 57], weightRange: [30, 35], bustRange: [24, 26.5], bandRange: null, differenceRange: [0, 2] },
        { stage: 'First stage (8-12 years old)', sizeUS: '12Y', sizeEU: '134', heightRange: [57, 61], weightRange: [35, 45], bustRange: [25.5, 28], bandRange: null, differenceRange: [0, 2] },
        { stage: 'First stage (8-12 years old)', sizeUS: '14Y', sizeEU: '140', heightRange: [61, 65], weightRange: [42.5, 50], bustRange: [27.5, 29.5], bandRange: null, differenceRange: [0, 2] },
        { stage: 'First stage (8-12 years old)', sizeUS: '18Y', sizeEU: '152', heightRange: [65, 69], weightRange: [50, 60], bustRange: [28.5, 31.5], bandRange: null, differenceRange: [0, 2] }
      ],
      second: [
        { stage: 'Second stage (12-14 years)', sizeUS: '12Y', sizeEU: '134', heightRange: [57, 61], weightRange: [35, 45], bustRange: [27, 29.5], bandRange: [23.5, 27], differenceRange: [2, 4] },
        { stage: 'Second stage (12-14 years)', sizeUS: '14Y', sizeEU: '140', heightRange: [61, 65], weightRange: [40, 50], bustRange: [29.5, 32.5], bandRange: [27.5, 29.5], differenceRange: [2, 4] },
        { stage: 'Second stage (12-14 years)', sizeUS: '18Y', sizeEU: '152', heightRange: [65, 69], weightRange: [50, 60], bustRange: [32.5, 35], bandRange: [29.5, 31.5], differenceRange: [2, 4] }
      ],
      third: [
        { stage: 'Third stage (14-16 years old)', sizeUS: '14Y', sizeEU: '140', heightRange: [61, 65], weightRange: [40, 50], bustRange: [30.5, 32.5], bandRange: [25.5, 27.6], differenceRange: [3, 5] },
        { stage: 'Third stage (14-16 years old)', sizeUS: '16Y', sizeEU: '146', heightRange: [65, 67], weightRange: [45, 57], bustRange: [32.5, 34.5], bandRange: [27.5, 29.5], differenceRange: [3, 5] },
        { stage: 'Third stage (14-16 years old)', sizeUS: '18Y', sizeEU: '152', heightRange: [67, 69], weightRange: [57, 67], bustRange: [34.5, 36.5], bandRange: [29.5, 31.5], differenceRange: [3, 5] },
        { stage: 'Third stage (14-16 years old)', sizeUS: '18Y', sizeEU: '158', heightRange: [69, 71], weightRange: [67, 77], bustRange: [36, 38], bandRange: [31.5, 33.5], differenceRange: [3, 5] }
      ]
    };
    
    const braSizeData = currentUnit === 'cm' ? braSizeDataCM : braSizeDataIN;

    const allData = [...braSizeData.first, ...braSizeData.second, ...braSizeData.third];
    
    // 计算每个 stage 的行数和 difference 值
    const stageCounts = {
      'First stage (8-12 years old)': braSizeData.first.length,
      'Second stage (12-14 years)': braSizeData.second.length,
      'Third stage (14-16 years old)': braSizeData.third.length
    };
    
    const stageDifferences = {
      'First stage (8-12 years old)': braSizeData.first[0].differenceRange,
      'Second stage (12-14 years)': braSizeData.second[0].differenceRange,
      'Third stage (14-16 years old)': braSizeData.third[0].differenceRange
    };
    
    let currentStage = null;
    let stageRowIndex = 0;
    
    allData.forEach((item, index) => {
      const row = document.createElement('tr');
      
      // Stage - 只在每个 stage 的第一行创建，并设置 rowspan
      if (item.stage !== currentStage) {
        currentStage = item.stage;
        stageRowIndex = 0;
        
        const stageCell = document.createElement('td');
        stageCell.textContent = item.stage;
        stageCell.setAttribute('rowspan', stageCounts[item.stage]);
        stageCell.style.verticalAlign = 'middle';
        
        // 为每个 stage 添加独立的 id
        if (item.stage === 'First stage (8-12 years old)') {
          stageCell.id = 'stage-first-kids';
        } else if (item.stage === 'Second stage (12-14 years)') {
          stageCell.id = 'stage-second-kids';
        } else if (item.stage === 'Third stage (14-16 years old)') {
          stageCell.id = 'stage-third-kids';
        }
        
        row.appendChild(stageCell);
      }
      
      // US/UK SIZE
      const sizeUSCell = document.createElement('td');
      sizeUSCell.textContent = item.sizeUS;
      row.appendChild(sizeUSCell);
      
      // EU SIZE
      const sizeEUCell = document.createElement('td');
      sizeEUCell.textContent = item.sizeEU;
      row.appendChild(sizeEUCell);
      
      // Height - 直接使用数据，不转换
      const heightCell = document.createElement('td');
      const heightText = `${item.heightRange[0]}-${item.heightRange[1]}`;
      heightCell.textContent = heightText;
      row.appendChild(heightCell);
      
      // Weight - 始终显示 KG，不进行单位转换
      const weightCell = document.createElement('td');
      const weightText = `${item.weightRange[0]}-${item.weightRange[1]}`;
      weightCell.textContent = weightText;
      row.appendChild(weightCell);
      
      // Bust - 直接使用数据，不转换
      const bustCell = document.createElement('td');
      const bustText = `${item.bustRange[0]}-${item.bustRange[1]}`;
      bustCell.textContent = bustText;
      row.appendChild(bustCell);
      
      // Band - 直接使用数据，不转换
      const bandCell = document.createElement('td');
      if (item.bandRange) {
        const bandText = `${item.bandRange[0]}-${item.bandRange[1]}`;
        bandCell.textContent = bandText;
      } else {
        bandCell.textContent = '-';
      }
      row.appendChild(bandCell);
      
      // Difference - 只在每个 stage 的第一行创建，并设置 rowspan
      if (stageRowIndex === 0) {
        const diffCell = document.createElement('td');
        const diffRange = stageDifferences[currentStage];
        const diffText = `${diffRange[0]}-${diffRange[1]}`;
        diffCell.textContent = diffText;
        diffCell.setAttribute('rowspan', stageCounts[currentStage]);
        diffCell.style.verticalAlign = 'middle';
        
        // 为每个 stage 的 difference 单元格添加独立的 id
        if (currentStage === 'First stage (8-12 years old)') {
          diffCell.id = 'difference-first-kids';
        } else if (currentStage === 'Second stage (12-14 years)') {
          diffCell.id = 'difference-second-kids';
        } else if (currentStage === 'Third stage (14-16 years old)') {
          diffCell.id = 'difference-third-kids';
        }
        
        row.appendChild(diffCell);
      }
      
      tableBody.appendChild(row);
      stageRowIndex++;
    });
    
    // 更新表头
    this.updateBraSizeTableHeader(currentUnit);
  }

  generateLoungeSizeTable(tableBody) {
    if (!tableBody) return;
    
    tableBody.innerHTML = '';
    const currentUnit = this.getCurrentUnit('kids-lounge');
    
    // Lounge Size 数据 - 分别存储 CM 和 INCH 数据，不进行转换
    const loungeSizeDataCM = [
      { sizeUS: '18-24 months', sizeEU: '18-24 months', heightRange: [85, 95], bustRange: [47, 53], waistRange: [47, 53], hipsRange: [49, 55] },
      { sizeUS: '3 years', sizeEU: '3 years', heightRange: [95, 105], bustRange: [49, 55], waistRange: [48, 54], hipsRange: [51, 57] },
      { sizeUS: '4 years', sizeEU: '110', heightRange: [105, 115], bustRange: [53, 59], waistRange: [49, 56], hipsRange: [54, 62] },
      { sizeUS: '6Y', sizeEU: '116', heightRange: [115, 125], bustRange: [57, 63], waistRange: [50, 59], hipsRange: [58, 66] },
      { sizeUS: '8Y', sizeEU: '122', heightRange: [125, 135], bustRange: [61, 67], waistRange: [51, 62], hipsRange: [62, 70] },
      { sizeUS: '10Y', sizeEU: '128', heightRange: [135, 145], bustRange: [63, 71], waistRange: [52, 64], hipsRange: [68, 76] },
      { sizeUS: '12Y', sizeEU: '134', heightRange: [145, 155], bustRange: [64, 76], waistRange: [56, 67], hipsRange: [72, 82] },
      { sizeUS: '14Y', sizeEU: '140', heightRange: [155, 160], bustRange: [68, 80], waistRange: [58, 70], hipsRange: [74, 84] },
      { sizeUS: '14Y', sizeEU: '140', heightRange: [160, 165], bustRange: [72, 84], waistRange: [61, 74], hipsRange: [78, 88] },
      { sizeUS: '16Y', sizeEU: '146', heightRange: [165, 170], bustRange: [76, 88], waistRange: [64, 78], hipsRange: [82, 92] },
      { sizeUS: '18Y', sizeEU: '152', heightRange: [170, 175], bustRange: [80, 92], waistRange: [67, 80], hipsRange: [86, 96] },
      { sizeUS: '18Y', sizeEU: '158', heightRange: [175, 180], bustRange: [84, 96], waistRange: [70, 82], hipsRange: [90, 100] },
      { sizeUS: '18Y', sizeEU: '164', heightRange: [170, 185], bustRange: [92, 100], waistRange: [78, 86], hipsRange: [96, 104] }
    ];
    
    const loungeSizeDataIN = [
      { sizeUS: '18-24 months', sizeEU: '18-24 months', heightRange: [33.5, 37.5], bustRange: [18.5, 21], waistRange: [18.5, 21], hipsRange: [19.5, 21.5] },
      { sizeUS: '3 years', sizeEU: '3 years', heightRange: [37.5, 41.5], bustRange: [19.5, 21.5], waistRange: [19, 21.5], hipsRange: [20, 22.5] },
      { sizeUS: '4 years', sizeEU: '110', heightRange: [41.5, 45.5], bustRange: [21, 23], waistRange: [19.5, 22], hipsRange: [21.5, 24.5] },
      { sizeUS: '6Y', sizeEU: '116', heightRange: [45.5, 49], bustRange: [22.5, 25], waistRange: [20, 23], hipsRange: [23, 26] },
      { sizeUS: '8Y', sizeEU: '122', heightRange: [49, 53], bustRange: [24.0, 26.5], waistRange: [20, 24.5], hipsRange: [24.5, 27.5] },
      { sizeUS: '10Y', sizeEU: '128', heightRange: [53, 57], bustRange: [25, 28.0], waistRange: [20.5, 25], hipsRange: [27, 30] },
      { sizeUS: '12Y', sizeEU: '134', heightRange: [57, 61], bustRange: [25, 30], waistRange: [22, 26.5], hipsRange: [28.5, 32.5] },
      { sizeUS: '14Y', sizeEU: '140', heightRange: [61, 63], bustRange: [27, 31.5], waistRange: [23, 27.5], hipsRange: [29, 33] },
      { sizeUS: '14Y', sizeEU: '140', heightRange: [63, 65], bustRange: [28.5, 33], waistRange: [24, 29], hipsRange: [31, 34.5] },
      { sizeUS: '16Y', sizeEU: '146', heightRange: [65, 67], bustRange: [30, 34.5], waistRange: [25, 30.5], hipsRange: [32.5, 36] },
      { sizeUS: '18Y', sizeEU: '152', heightRange: [67, 69], bustRange: [31.5, 36], waistRange: [26.5, 31.5], hipsRange: [34, 38] },
      { sizeUS: '18Y', sizeEU: '158', heightRange: [69, 71], bustRange: [33, 38], waistRange: [27.5, 32.5], hipsRange: [35.5, 39.5] },
      { sizeUS: '18Y', sizeEU: '164', heightRange: [71, 72.5], bustRange: [36, 39.5], waistRange: [30.5, 34], hipsRange: [38, 41] }
    ];
    
    const loungeSizeData = currentUnit === 'cm' ? loungeSizeDataCM : loungeSizeDataIN;
    
    loungeSizeData.forEach((item) => {
      const row = document.createElement('tr');
      
      // US/UK SIZE
      const sizeUSCell = document.createElement('td');
      sizeUSCell.textContent = item.sizeUS;
      row.appendChild(sizeUSCell);
      
      // EU SIZE
      const sizeEUCell = document.createElement('td');
      sizeEUCell.textContent = item.sizeEU;
      row.appendChild(sizeEUCell);
      
      // Height - 直接使用数据，不转换
      const heightCell = document.createElement('td');
      const heightText = `${item.heightRange[0]}-${item.heightRange[1]}`;
      heightCell.textContent = heightText;
      row.appendChild(heightCell);
      
      // Bust - 直接使用数据，不转换
      const bustCell = document.createElement('td');
      const bustText = `${item.bustRange[0]}-${item.bustRange[1]}`;
      bustCell.textContent = bustText;
      row.appendChild(bustCell);
      
      // Waist - 直接使用数据，不转换
      const waistCell = document.createElement('td');
      const waistText = `${item.waistRange[0]}-${item.waistRange[1]}`;
      waistCell.textContent = waistText;
      row.appendChild(waistCell);
      
      // Hips - 直接使用数据，不转换
      const hipsCell = document.createElement('td');
      const hipsText = `${item.hipsRange[0]}-${item.hipsRange[1]}`;
      hipsCell.textContent = hipsText;
      row.appendChild(hipsCell);
      
      tableBody.appendChild(row);
    });
    
    // 更新表头
    this.updateLoungeSizeTableHeader(currentUnit);
  }

  updateBraSizeTableHeader(unit) {
    const heightHeader = document.getElementById('bra-height-header-kids');
    const weightHeader = document.getElementById('bra-weight-header-kids');
    const bustHeader = document.getElementById('bra-bust-header-kids');
    const bandHeader = document.getElementById('bra-band-header-kids');
    const diffHeader = document.getElementById('bra-difference-header-kids');
    
    if (heightHeader) {
      heightHeader.textContent = unit === 'cm' ? 'Height (CM)' : 'Height (INCH)';
    }
    if (weightHeader) {
      // Weight 列始终显示 KG，不根据单位切换
      weightHeader.textContent = 'Weight (KG)';
    }
    if (bustHeader) {
      bustHeader.textContent = unit === 'cm' ? 'Bust (CM)' : 'Bust (INCH)';
    }
    if (bandHeader) {
      bandHeader.textContent = unit === 'cm' ? 'Band (CM)' : 'Band (INCH)';
    }
    if (diffHeader) {
      diffHeader.textContent = unit === 'cm' ? 'Difference between Bust and Band (CM)' : 'Difference between Bust and Band (INCH)';
    }
  }

  updateLoungeSizeTableHeader(unit) {
    const heightHeader = document.getElementById('lounge-height-header-kids');
    const bustHeader = document.getElementById('lounge-bust-header-kids');
    const waistHeader = document.getElementById('lounge-waist-header-kids');
    const hipsHeader = document.getElementById('lounge-hips-header-kids');
    
    if (heightHeader) {
      heightHeader.textContent = unit === 'cm' ? 'Height (CM)' : 'Height (INCH)';
    }
    if (bustHeader) {
      bustHeader.textContent = unit === 'cm' ? 'Bust (CM)' : 'Bust (INCH)';
    }
    if (waistHeader) {
      waistHeader.textContent = unit === 'cm' ? 'Waist (CM)' : 'Waist (INCH)';
    }
    if (hipsHeader) {
      hipsHeader.textContent = unit === 'cm' ? 'Hips (CM)' : 'Hips (INCH)';
    }
  }

  // 获取当前单位
  getCurrentUnit(type) {
    const activeBtn = document.querySelector(`[data-type="${type}"].bra-size-calculator__unit-btn.active`);
    return activeBtn ? activeBtn.dataset.unit : 'in';
  }

  // 处理单位切换
  handleUnitToggle(unit, type) {
    // 更新按钮状态
    const unitBtns = document.querySelectorAll(`[data-type="${type}"].bra-size-calculator__unit-btn`);
    unitBtns.forEach(btn => {
      btn.classList.remove('active');
      if (btn.dataset.unit === unit) {
        btn.classList.add('active');
      }
    });

    // 更新标签
    if (type === 'kids-bra') {
      const unitLabels = document.querySelectorAll('.unit-label-kids-bra');
      const unitText = unit === 'cm' ? 'cm' : 'inches';
      unitLabels.forEach(label => {
        label.textContent = unitText;
      });
    } else if (type === 'kids-lounge') {
      const unitLabels = document.querySelectorAll('.unit-label-kids-lounge');
      const unitText = unit === 'cm' ? 'cm' : 'inches';
      unitLabels.forEach(label => {
        label.textContent = unitText;
      });
    }

    // 更新 placeholder
    if (type === 'kids-bra') {
      this.updateKidsBraInputPlaceholder(unit);
    } else if (type === 'kids-lounge') {
      this.updateKidsLoungeInputPlaceholder(unit);
    }

    // 转换输入框的值
    if (type === 'kids-bra') {
      this.convertInputValues('height-measurement-kids-bra', unit);
    } else if (type === 'kids-lounge') {
      this.convertInputValues('height-measurement-kids-lounge', unit);
    }

    // 更新输入框的 data-unit 属性
    const inputs = document.querySelectorAll(`input[data-unit]`);
    inputs.forEach(input => {
      if (input.id.includes(type) && (input.dataset.unit === 'in' || input.dataset.unit === 'cm')) {
        input.dataset.unit = unit;
      }
    });

    // 重新生成表格
    this.generateSizeTable();
  }

  // 转换输入框值
  convertInputValues(inputId, targetUnit) {
    const input = document.getElementById(inputId);
    if (!input || !input.value) return;

    const currentValue = parseFloat(input.value);
    if (isNaN(currentValue)) return;

    const currentUnit = input.dataset.unit || 'in';
    
    if (currentUnit === targetUnit) return;

    let convertedValue;
    if (currentUnit === 'in' && targetUnit === 'cm') {
      convertedValue = currentValue * 2.54;
    } else if (currentUnit === 'cm' && targetUnit === 'in') {
      convertedValue = currentValue / 2.54;
    } else {
      return;
    }

    input.value = convertedValue.toFixed(1);
    input.dataset.unit = targetUnit;
  }

  updateKidsBraInputPlaceholder(unit) {
    const heightInput = document.getElementById('height-measurement-kids-bra');
    const unitText = unit === 'cm' ? 'cm' : 'inches';
    
    if (heightInput) {
      heightInput.placeholder = `Height (${unitText})`;
    }
  }

  updateKidsLoungeInputPlaceholder(unit) {
    const heightInput = document.getElementById('height-measurement-kids-lounge');
    const unitText = unit === 'cm' ? 'cm' : 'inches';
    
    if (heightInput) {
      heightInput.placeholder = `Height (${unitText})`;
    }
  }
}

// 初始化儿童尺码计算器
document.addEventListener('DOMContentLoaded', () => {
  const kidsModal = document.getElementById('bra-size-calculator-kids');
  if (kidsModal) {
    window.braSizeCalculatorKids = new KidsSizeCalculator();
    window.braSizeCalculatorKids.modal = kidsModal;
    window.braSizeCalculatorKids.type = 'kids';
    window.braSizeCalculatorKids.init();
  }
});
